var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-container"},[_c(_setup.MessageList,{staticStyle:{"background-color":"#fff"}}),_c(_setup.ChatEditor,{staticStyle:{"background-color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }